import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getEditPointTableSystemV2 = createSlice({
    name: 'EditPointTableSystemV2',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchEditPointTableSystemV2.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchEditPointTableSystemV2.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchEditPointTableSystemV2.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setEditPointTableSystemV2 , setStatus} = getEditPointTableSystemV2.actions;
export default getEditPointTableSystemV2.reducer;

export const fetchEditPointTableSystemV2 = createAsyncThunk('/EditPointTableSystemV2get/fetch', async({id}) => {
    const res = await axios.get(`${window.env.API_URL}/GetEditPointTableSystemV2/${id}`);
    const EditPointTableSystemV2Data = res.data;
    return EditPointTableSystemV2Data.data.PointSystemidDataOfCompetition;
})